import React from "react";
import { useTranslation } from "react-i18next";

import underlineimage from "../assets/images/title-shape.png";
import playerwin from "../assets/images/Esportsec/EsportsRoundImgs/sportsdraftplayerwin.png";
import frnbbg from "../assets/images/gaming-stats-bg.png";

import iconMode from "../assets/images/sportsdraft/modee.png";
import iconPower from "../assets/images/sportsdraft/powerplayy.png";
import icon1v1 from "../assets/images/sportsdraft/third.png";

const GamingStats: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative bg-[#070b28] bg-no-repeat bg-contain bg-bottom pt-16 pb-10 px-4 md:px-6 lg:px-8 overflow-hidden"
      style={{ backgroundImage: `url(${frnbbg})` }}
    >
      {/* Title */}
      <div className="text-center relative z-20 mb-12">
        <h2 className="text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-oswald font-extrabold text-white leading-tight">
          {t("gamingStats.title")} <br className="hidden md:block" /> {t("gamingStats.subtitle")}
        </h2>
        <img
          src={underlineimage}
          alt="underline"
          className="mx-auto mt-2 mb-4 w-[100px] sm:w-[120px] h-auto"
        />
        <p className="text-[14px] sm:text-[15px] md:text-[16px] leading-[22px] text-white/80 font-proxima max-w-2xl mx-auto">
          {t("gamingStats.descriptiont")}
        </p>
      </div>

      {/* Grid Section */}
      <div className="mx-auto max-w-[1300px] grid lg:grid-cols-2 gap-12 md:gap-20 items-center">
        {/* Left Image */}
        <div className="flex justify-center lg:justify-start">
          <img
            src={playerwin}
            alt="Player Win"
            className="w-full max-w-[600px] h-auto"
          />
        </div>

        {/* Right Features */}
        <div className="text-white w-full flex flex-col justify-center">
          {/* Feature 1 */}
          <div className="flex items-center gap-5 mb-8">
            <img src={iconMode} alt="Mode Icon" className="w-[60px] sm:w-[70px] h-auto" />
            <div>
              <h4 className="font-bold uppercase text-[15px] sm:text-[16px]">
                {t("gamingStats.pickerTitle")}
              </h4>
              <p className="uppercase text-sm text-white/70">{t("gamingStats.pickerSubtitle")}</p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-center gap-5 mb-8">
            <img src={iconPower} alt="Power Icon" className="w-[60px] sm:w-[70px] h-auto" />
            <div>
              <h4 className="font-bold uppercase text-[15px] sm:text-[16px]">
                {t("gamingStats.powerTitle")}
              </h4>
              <p className="uppercase text-sm text-white/70">{t("gamingStats.powerSubtitle")}</p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="flex items-center gap-5">
            <img src={icon1v1} alt="1v1 Icon" className="w-[60px] sm:w-[70px] h-auto" />
            <div>
              <h4 className="font-bold uppercase text-[15px] sm:text-[16px]">
                {t("gamingStats.vsTitle")}
              </h4>
              <p className="uppercase text-sm text-white/70">{t("gamingStats.vsSubtitle")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamingStats;
